import { AppRoutes } from "../../routes/routes";
import { ViewModelContainer } from "../../viewmodel/viewmodel";
export class UserIdViewModel {
    store;
    name = this.constructor.name;
    constructor(store) {
        this.store = store;
    }
    get userId() {
        return this.store.userId;
    }
    setUserId(userId) {
        this.store.setUserId(userId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    notifyLocationChanged(route, params) {
        // clear stored user id when visiting /user page
        if (route === AppRoutes.Home || route === AppRoutes.User) {
            this.setUserId("");
            ViewModelContainer.resetContainerWithUserId("");
            window.history.pushState(null, "", window.location.href);
        }
    }
}
